import React, {
  useRef,
  RefObject,
  Dispatch,
  CSSProperties,
  useState,
  useEffect,
} from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { StoreState } from "../redux/store/types";
import * as selectors from "../redux/selectors";
import { SQLDate } from "@soltshared/shared-domain/util";
import { Show } from "../domain/board-ticketing";
import { useHotkeys } from "react-hotkeys-hook";
import classNames from "classnames";
import { boardUIInit } from "../redux/actions";
import { BoardUIInit } from "../redux/actions/types";
import { useWindowSize } from "react-hooks-window-size";
import { DateTime } from "luxon";

import audioDescribeIcon from "../images/icons/Audio-describe-con-PC.png";
import captionedIcon from "../images/icons/Captioned-icon-PC.png";
import relaxedPerformanceIcon from "../images/icons/Relaxed-Performance-icon-1.png";
import signedIcon from "../images/icons/Signed-icon-PC.png";
//import OpeningThenFeatured from "./protos/OpeningThenFeatured";
import ShowOfTheWeekUI from "./protos/ShowOfTheWeekUI";

const windowWidth = window.innerWidth;

function sortTitleForShowTitle(title: string): string {
  const replacements = [/^the /i, /^les /i, /^la /i, /^disney's the /i];

  return _.reduce(
    replacements,
    (acc, regex) => {
      return acc.replace(regex, "");
    },
    title
  );
}

const ShowUI = connect(
  (
    state: StoreState,
    ownProps: {
      show: Show;
      date: SQLDate;
    }
  ) => {
    return {};
  }
)((props: { show: Show; index: number }) => {
  const { show } = props;
  const showRef = useRef<HTMLDivElement>(null);

  let performancesWithPrices = _.orderBy(show.performancesToShow, "starts");

  if (_.isEmpty(performancesWithPrices)) {
    return null;
  }

  const isMultiPart = !_.isEmpty((show.performancesToShow || []).filter(perf => {
    return perf.part_number;
  }));

  const now = DateTime.local();
  const daySeatsOnSaleTime = now.startOf("day").plus({hours: 10});
  const shouldDisplayDaySeats = now > daySeatsOnSaleTime && show.hasDaySeats;

  return (
    <article
      className={`white bg-white-10 br1 relative overflow-hidden           ${
          show.showOfTheWeek
            ? "show-of-the-week-item"
            : ""
          }`}
      style={{marginBottom: "2px"}}
      ref={showRef}
    >

      <div
        className={`flex flex-row justify-between items-start z-1 br4 relative`}
      >
        <div className="w-30 image-container w-22:5-xl">
          <div className="aspect-ratio--2x1 relative">
            { show.image && (
              <img
                src={show.image.replace("http://", "https://")}
                alt={show.show_name}
                className="w-100 h-100 br0 absolute top-0 left-0 "
              />
            )}
            { show.showOfTheWeek && (
                <span className="show-of-the-week-label">Show Of The Week</span>
            )}
          </div>
        </div>
        <div className={`flex flex-row flex-wrap justify-between relative ml2 flex-grow-1 overflow-hidden
          `}>
                <h3
        className={`f2:5 fw8 lh-title w-100 br1 br--top pb1 pt1`}>
      
        <span className="ml2 w-80 w-60-xl dib">
          {show.show_name}
        </span>
      </h3>
          <div className="flex flex-row w-100">
            {_.map(performancesWithPrices, (performance, i: number) => {
              let accessKeys = _.chain(performance.accessPerformances)
                .flatMap((access) => access.performance_type)
                .uniq()
                .value();
              
                let discountAvailable = null;
                if (show.provider === 'lineup' && performance.source === 'tkts-booth') {
                  const groupedPrices = _.groupBy(performance.prices, 'priceband');
                  _.map(groupedPrices, (prices) => {
                    const tktsPrice = _.find(prices, (price) => price.location.includes('TKTS'));
                    const standardPrice = _.find(prices, (price) => !price.location.includes('TKTS'));
  
                    if (tktsPrice) {
                      if (standardPrice) {
                        const saving = Math.floor(((standardPrice.ticketprice - tktsPrice.ticketprice) / standardPrice.ticketprice) * 100);
                        discountAvailable = saving > 0 ? saving : 0;
                      }
                    }
                  })
                } else {
                  discountAvailable = _.chain(performance.prices)
                  .filter((price) => price.onsale && price.fullprice)
                  .map((price: any) => {
                    return Math.floor(
                      ((price.fullprice! - price.ticketprice) /
                        price.fullprice!) *
                        100
                    );
                  })
                  .max()
                  .value();
                }


              let priceString: string | undefined;
              if (typeof performance.price_from  === "number" && typeof performance.price_to ==="number") {
                priceString = performance.price_from === performance.price_to
                    ? `£${performance.price_from.toFixed(2)}`
                    : `£${performance.price_from.toFixed(
                        2
                      )} - £${performance.price_to.toFixed(2)}`;
              }

              let partLabel: undefined | string;
              if (performance.part_number) {
                partLabel = `Part ${performance.part_number === 1 ? 'One' : 'Two'}`;
              }

              return (
                <div className="flex relative align-stretch">
                  <div
                    className="tc ph2 flex flex-column"
                    style={{ minWidth: "105px" }}
                    key={i + performance.starts}
                  >
                    <div
                      className={`br2 br--top ba pv0 fw7 f3:5 w-100 flex items-center justify-center bg-white black-70 b--white`}
                    >
                      <span>
                        { partLabel && <span>{ partLabel } </span>}
                        {DateTime.fromSQL(performance.starts).toFormat("h:mma")}
                      </span>

                      {_.includes(accessKeys, "audio") && (
                        <img
                          className="w1 h1 ml2"
                          src={audioDescribeIcon}
                          alt="Audio Described Performance"
                          width="40"
                          height="40"
                        />
                      )}
                      {_.includes(accessKeys, "captioned") && (
                        <img
                          className="w1 h1 ml2"
                          src={captionedIcon}
                          alt="Captioned Performance"
                          width="40"
                          height="40"
                        />
                      )}
                      {_.includes(accessKeys, "signed") && (
                        <img
                          className="w1 h1 ml2"
                          src={signedIcon}
                          alt="Sign Language Interpreted"
                          width="40"
                          height="40"
                        />
                      )}
                      {_.includes(accessKeys, "relaxed") && (
                        <img
                          className="w1 h1 ml2"
                          src={relaxedPerformanceIcon}
                          alt="Relaxed Performance"
                          width="40"
                          height="40"
                        />
                      )}
                    </div>
                    <div
                      className={`fw8 f3:5 bb bl br br2 br--bottom h-100 w-100 flex flex-column items-center justify-center shadow-4 bg-white-10 b--white `}
                      style={{ minHeight: "26px" }}
                    >
                      <div className="pv1">{priceString}</div>
                      {discountAvailable && discountAvailable > 0 && (
                        <div className="bg-tkts-red pv0 ph1 fw7 f3:5 w-100">
                          Up to {discountAvailable}% off
                        </div>
                      )}
                    </div>
                  </div>  
                </div>
              );
            })}
            {
              isMultiPart && (
                <div
                  className="self-end br2 pa2 flex flex-column bg-white-10 justify-end f3:5"
                  style={{ width: "auto" }}>
                  <span className="ttu mb1">* Please note</span>
                  <span className="">You must purchase tickets for both parts of this show</span>
                </div>
              ) 
            }
            {shouldDisplayDaySeats && 
              <div
                className="self-end br2 pa2 flex flex-column bg-white-10 justify-end f3:5"
                >
                <p className="f3:5" style={{ color: "#F48123" }}>{show.daySeatPriceString} Day Seats available!</p>
                <p className="f3:5 mt1 white o-80">Ask at window for more details</p>
              </div>
            }   
          </div>
        </div>
      </div>
    </article>
  );
});

const createSpacers = (
  params: {
    viewport: RefObject<HTMLDivElement>;
    showsList: RefObject<HTMLDivElement>;
  },
  setPages: any,
  initiateBoard: any
) => {
  const calculatePages = (
    viewport: RefObject<HTMLDivElement>,
    showsList: RefObject<HTMLDivElement>
  ) => {
    if (viewport.current && showsList.current) {
      const viewportHeight = viewport.current.offsetHeight;
      const showsElements = showsList.current.children;
      const pages = [
        {
          spacerAfterShowUrl: null,
          spacerHeight: 0,
          pageHeight: 0,
          offsetTop: 0,
        },
      ] as any[];

      const els = Array.prototype.slice.call(showsElements) as HTMLDivElement[];

      for (let i = 0; i < els.length; i++) {
        const el = els[i];
        const currentPage = _.last(pages);

        if (currentPage.pageHeight + el.offsetHeight >= viewportHeight) {
          const prevEl = els[i - 1];
          if (!prevEl) {
            continue;
          }

          // split across the end of a page, so finish up the
          // current spacer and start a new one
          currentPage.spacerHeight = viewportHeight - currentPage.pageHeight;
          currentPage.spacerAfterShowUrl = prevEl.dataset.showUrl;

          const spacerHeights = _.reduce(
            pages,
            (acc, page) => {
              return acc + page.spacerHeight;
            },
            0
          );

          pages.push({
            spacerAfterShowUrl: null,
            spacerHeight: 0,
            pageHeight: el.offsetHeight,
            offsetTop: spacerHeights + el.offsetTop,
          });
        } else {
          currentPage.pageHeight += el.offsetHeight;
        }
      }
      return pages;
    } else {
      return [];
    }
  };

  const pages = calculatePages(params.viewport, params.showsList);

  initiateBoard({
    page: {
      pageCount: pages.length,
      pageNumber: 0,
    },
    initiated: true,
  });

  setPages(pages);
};

const ShowsList = (params: {
  pageState: any;
  viewportRef: RefObject<HTMLDivElement>;
  showsRef: RefObject<HTMLDivElement>;
  shows: Show[];
  date: any;
  boardState: StoreState["boardUI"];
  initiateBoard: Dispatch<BoardUIInit>;
}) => {
  const [pages, setPages] = useState({} as any);
  const {
    pageState,
    viewportRef,
    showsRef,
    date,
    shows,
    boardState,
    initiateBoard,
  } = params;

  const currentPage = _.get(pages, [pageState.pageNumber], null);

  const sortedShows = _.chain(shows)
    .sortBy((show) => {
      return sortTitleForShowTitle(show.show_name);
    })
    .unionBy("url")
    .value();

  useEffect(() => {
    console.log("createSpacers");
    createSpacers(
      {
        viewport: viewportRef,
        showsList: showsRef,
      },
      setPages,
      initiateBoard
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boardState.now, boardState.page.pageNumber === pages.length]);

  return (
    <div className={`flex flex-column w-100 ph1`}>
            <div
        className={classNames(
          "flex flex-row items-center justify-between w-100 white ph2"
        )}
        style={{ minHeight: "24px", marginBottom: "4px" }}
      >
        <div className="sans-serif fw4 f7 lh-copy mv0 db flex items-center">
          <div>Preferred payment partner</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            viewBox="0 0 152.407 108"
            className="ml2"
          >
            <g>
              <rect width="152.407" height="108" style={{ fill: "none" }} />
              <g>
                <rect
                  x="60.4117"
                  y="25.6968"
                  width="31.5"
                  height="56.6064"
                  style={{ fill: "#ff5f00" }}
                />
                <path
                  d="M382.20839,306a35.9375,35.9375,0,0,1,13.7499-28.3032,36,36,0,1,0,0,56.6064A35.938,35.938,0,0,1,382.20839,306Z"
                  transform="translate(-319.79649 -252)"
                  style={{ fill: "#eb001b" }}
                />
                <path
                  d="M454.20349,306a35.99867,35.99867,0,0,1-58.2452,28.3032,36.00518,36.00518,0,0,0,0-56.6064A35.99867,35.99867,0,0,1,454.20349,306Z"
                  transform="translate(-319.79649 -252)"
                  style={{ fill: "#f79e1b" }}
                />
                <path
                  d="M450.76889,328.3077v-1.1589h.4673v-.2361h-1.1901v.2361h.4675v1.1589Zm2.3105,0v-1.3973h-.3648l-.41959.9611-.41971-.9611h-.365v1.3973h.2576v-1.054l.3935.9087h.2671l.39351-.911v1.0563Z"
                  transform="translate(-319.79649 -252)"
                  style={{ fill: "#f79e1b" }}
                />
              </g>
            </g>
          </svg>
        </div>
        <div className="lh-copy fw7 f7">
          Page {pageState.pageNumber + 1}/{pages.length}
        </div>
      </div>
      <div
        className="flex-auto shows-container relative overflow-y-hidden "
        ref={viewportRef}
      >
        <div
          className="shows-wrapper"
          style={{
            transition: "transform ease 1.25s",
            transform: `translateY(-${
              currentPage ? currentPage.offsetTop : 0
            }px`,
          }}
          ref={showsRef}
        >
          {_.map(sortedShows, (show, i) => {
            if (i === 0) {
            }
            const spacer = _.find(pages, (page) => {
              return page.spacerAfterShowUrl === show.url;
            });

            return (
              <div
                key={show.show_url}
                className={classNames("show-item overflow-hidden ")}
                data-show-url={show.url}
              >
                <ShowUI show={show} date={date} index={i} />
                {spacer && boardState.renderSpacers && (
                  <div
                    className="spacer"
                    style={{ height: spacer.spacerHeight }}
                  />
                )}
              </div>
            );
          })}
          {DateTime.local().toISO() < "2021-09-14" && (
            <img
              src="https://images-positive.officiallondontheatre.com/solt/image/upload/v1628590338/TKTSBooth/TKTS_-_Only_Available_online.png"
              alt="Only available online"
              className="w-100 vh-100 "
            />
          )}
        </div>
      </div>

    </div>
  );
};

export const BoardControlsUI = (props: { displayDate: SQLDate }) => {
  const { displayDate } = props;

  const [hidden, setHidden] = useState(true);
  useHotkeys("ctrl+y", () => {
    setHidden(!hidden);
  });

  if (hidden) {
    return null;
  }

  const navigateWithNewParams = (params: URLSearchParams) => {
    const { protocol, host, pathname } = window.location;
    const nextHref = `${protocol}//${host}${pathname}?${params.toString()}`;
    window.location.href = nextHref;
  };

  return (
    <div className="relative top-0 left-0 right-0">
      <div className="bg-light-gray pa3">
        <div className="flex flex-row items-center">
          <label>
            View board for date:
            <input
              className="ml2"
              type="date"
              required={true}
              value={displayDate}
              onChange={(e) => {
                const params = new URLSearchParams(window.location.search);
                params.set("date", e.target.value);
                navigateWithNewParams(params);
              }}
            />
          </label>
        </div>

        {/* <div className="mt3">
          <select
            defaultValue={useLegacyTKTSEndpoint ? "legacy" : "api"}
            onChange={e => {
              const params = new URLSearchParams(window.location.search);
              params.set(
                "legacytkts",
                e.target.value === "legacy" ? "true" : "false"
              );
              navigateWithNewParams(params);
            }}
          >
            <option value="legacy">Use data from TKTS uploader</option>
            <option value="api">Use data from TKTS API</option>
          </select>
        </div> */}
      </div>
    </div>
  );
};

export const BoardUI = connect(
  (state: StoreState) => {
    const displayDate = selectors.displayDate(state);
    const shows = selectors.showsForDateTime(state, displayDate);
    return {
      date: displayDate,
      shows: _.values(shows) as Show[],
      boardState: state.boardUI,
    };
  },
  (dispatch: Dispatch<BoardUIInit>, ownProps) => {
    return {
      initiateBoard: ({ page }: BoardUIInit) => {
        dispatch(boardUIInit(page, true));
      },
    };
  }
)(
  (props: {
    date: SQLDate;
    shows: Show[];
    initiateBoard: Dispatch<BoardUIInit>;
    boardState: any;
  }) => {
    const { date, shows, initiateBoard, boardState } = props;

    if (_.isEmpty(shows)) {
      return (
        <div className="bg-black flex flex-column vh-100 overflow-hidden">
          <BoardControlsUI displayDate={date} />
          <div className="h-100 flex flex-column items-center justify-center mw9 center tc fw7 f2 pa4 white-90 mt4 lh-copy">
            <img src="/olt.svg" alt="Official London Theatre" width="128" />
            <h3 className="lh-title mb4 mt4">
              Our great prices are also available to buy online
              <br />
              officiallondontheatre.com
            </h3>
            <h3>Follow us on social for the latest news and offers</h3>
            <div className="white-90 lh-copy f2 mt4">
              <span className="db flex items-center w-100 ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1024 1017.78"
                  className="w2 h2 mr4"
                >
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Ebene_1" data-name="Ebene 1">
                      <path
                        d="M1024,512C1024,229.23,794.77,0,512,0S0,229.23,0,512c0,255.55,187.23,467.37,432,505.78V660H302V512H432V399.2C432,270.88,508.44,200,625.39,200c56,0,114.61,10,114.61,10V336H675.44c-63.6,0-83.44,39.47-83.44,80v96H734L711.3,660H592v357.78C836.77,979.37,1024,767.55,1024,512Z"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>

                <span>OfficialLondonTheatre</span>
              </span>
              <span className="db flex items-center w-100 mt3">
                <svg
                  version="1.1"
                  id="White"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 400 400"
                  className="w2 h2 mr4"
                >
                  <path
                    className="st0"
                    fill="#ffffff"
                    d="M400,200c0,110.5-89.5,200-200,200S0,310.5,0,200S89.5,0,200,0S400,89.5,400,200z M163.4,305.5
	c88.7,0,137.2-73.5,137.2-137.2c0-2.1,0-4.2-0.1-6.2c9.4-6.8,17.6-15.3,24.1-25c-8.6,3.8-17.9,6.4-27.7,7.6
	c10-6,17.6-15.4,21.2-26.7c-9.3,5.5-19.6,9.5-30.6,11.7c-8.8-9.4-21.3-15.2-35.2-15.2c-26.6,0-48.2,21.6-48.2,48.2
	c0,3.8,0.4,7.5,1.3,11c-40.1-2-75.6-21.2-99.4-50.4c-4.1,7.1-6.5,15.4-6.5,24.2c0,16.7,8.5,31.5,21.5,40.1c-7.9-0.2-15.3-2.4-21.8-6
	c0,0.2,0,0.4,0,0.6c0,23.4,16.6,42.8,38.7,47.3c-4,1.1-8.3,1.7-12.7,1.7c-3.1,0-6.1-0.3-9.1-0.9c6.1,19.2,23.9,33.1,45,33.5
	c-16.5,12.9-37.3,20.6-59.9,20.6c-3.9,0-7.7-0.2-11.5-0.7C110.8,297.5,136.2,305.5,163.4,305.5"
                  />
                </svg>

                <span>london_theatre</span>
              </span>
              <span className="db flex items-center w-100 mt3">
                <span className="br-100 w2 h2 bg-white mr4 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 503.84 503.84"
                    className="w2:5 h2:5"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Logo">
                        <path d="M251.92,45.39c67.27,0,75.23.26,101.8,1.47,24.56,1.12,37.9,5.22,46.78,8.67a78,78,0,0,1,29,18.85,78,78,0,0,1,18.85,29c3.45,8.88,7.55,22.22,8.67,46.78,1.21,26.57,1.47,34.53,1.47,101.8s-.26,75.23-1.47,101.8c-1.12,24.56-5.22,37.9-8.67,46.78a83.51,83.51,0,0,1-47.81,47.81c-8.88,3.45-22.22,7.55-46.78,8.67-26.56,1.21-34.53,1.47-101.8,1.47s-75.24-.26-101.8-1.47c-24.56-1.12-37.9-5.22-46.78-8.67a78,78,0,0,1-29-18.85,78,78,0,0,1-18.85-29c-3.45-8.88-7.55-22.22-8.67-46.78-1.21-26.57-1.47-34.53-1.47-101.8s.26-75.23,1.47-101.8c1.12-24.56,5.22-37.9,8.67-46.78a78,78,0,0,1,18.85-29,78,78,0,0,1,29-18.85c8.88-3.45,22.22-7.55,46.78-8.67,26.57-1.21,34.53-1.47,101.8-1.47m0-45.39c-68.42,0-77,.29-103.87,1.52S102.93,7,86.9,13.23A123.52,123.52,0,0,0,42.28,42.28a123.52,123.52,0,0,0-29,44.62C7,102.93,2.74,121.24,1.52,148.05S0,183.5,0,251.92s.29,77,1.52,103.87S7,400.91,13.23,416.94a123.52,123.52,0,0,0,29.05,44.62A123.68,123.68,0,0,0,86.9,490.62c16,6.22,34.34,10.48,61.15,11.71s35.45,1.51,103.87,1.51,77-.29,103.87-1.51,45.12-5.49,61.15-11.71a128.85,128.85,0,0,0,73.68-73.68c6.22-16,10.48-34.34,11.71-61.15s1.51-35.45,1.51-103.87-.29-77-1.51-103.87-5.49-45.12-11.71-61.15a123.68,123.68,0,0,0-29.06-44.62,123.52,123.52,0,0,0-44.62-29C400.91,7,382.6,2.74,355.79,1.52S320.34,0,251.92,0Z" />
                        <path d="M251.92,122.56A129.37,129.37,0,1,0,381.29,251.92,129.35,129.35,0,0,0,251.92,122.56Zm0,213.33a84,84,0,1,1,84-84A84,84,0,0,1,251.92,335.89Z" />
                        <circle cx="386.4" cy="117.44" r="30.23" />
                      </g>
                    </g>
                  </svg>
                </span>

                <span>londontheatre</span>
              </span>
            </div>
          </div>
        </div>
      );
    }

    const viewContainer = useRef<HTMLDivElement>(null);
    const viewport = useRef<HTMLDivElement>(null);

    const showsList = useRef<HTMLDivElement>(null);

    const scalingEnabled = false;
    const windowSize = useWindowSize();

    let scaleStyle: CSSProperties = {};
    const targetWidth = 600;
    const targetHeight = 1000;
    if (scalingEnabled && windowSize && windowSize.height !== targetHeight) {
      const scaleFactor = windowSize.height / targetHeight;
      scaleStyle = {
        transformOrigin: "left top",
        transform: `scale(${scaleFactor})`,
        height: targetHeight,
        width: targetWidth,
      };
    }

    if (windowSize.width !== windowWidth) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }

    return (
      <div
        className="bg-black flex flex-column vh-100 overflow-hidden"
        style={scaleStyle}
      >
        <BoardControlsUI displayDate={date} />

       
        <ShowOfTheWeekUI />

        <div
          className="flex-auto flex flex-row overflow-hidden"
          ref={viewContainer}
        >
          <ShowsList
            viewportRef={viewport}
            showsRef={showsList}
            pageState={boardState.page}
            date={date}
            shows={shows}
            boardState={boardState}
            initiateBoard={initiateBoard}
          />
        </div>
        <div 
        className="footer-section">
          <div className="qr-code footer-section--inner">
            <div 
            className="qr-code-container">
              <img src="/qr.svg" alt="https://officiallondontheatre.com/tkts/" />
            </div>
            <div
            className="qr-code-text">
              <h3 className="white">For more information, and to book our same great priced tickets online visit <span>officiallondontheatre.com</span></h3>
            </div>

          </div>
          <div className="opening-hours footer-section--inner">
              {/* <h3 className="white">Opening<br />Times</h3> */}
              <h3 className="white">Mon - Sat<br />10:30am - 6pm</h3>
              <h3 className="white">Sun<br />12pm - 4:30pm</h3>
          </div>
        </div>
      </div>
    );
  }
);